export const NAMESPACE = 'KanBo/boards/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_BACKGROUND = NAMESPACE + 'SET_BACKGROUND'
export const SET_IS_CLOSED = NAMESPACE + 'SET_IS_CLOSED'
export const SET_IS_PUBLIC = NAMESPACE + 'SET_IS_PUBLIC'
export const SET_IS_LOCKED = NAMESPACE + 'SET_IS_LOCKED'

const initialState = { }

const boardDefaults = {
  id: 0,
  name: '',
  background: null,
  hasAccess: true,
  isClosed: false,
  isPublic: false,
  isLocked: false,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...boardDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(board => {
        newState[board.id] = {
          ...boardDefaults,
          ...newState[board.id],
          ...board
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_BACKGROUND:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          background: action.payload.background
        }
      } : state
    case SET_IS_CLOSED:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isClosed: action.payload.isClosed
        }
      } : state
    case SET_IS_PUBLIC:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isPublic: action.payload.isPublic
        }
      } : state
    case SET_IS_LOCKED:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isLocked: action.payload.isLocked
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (boardArray) {
  return {
    type: ADD_ARRAY,
    payload: boardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setBackground ({ id, background }) {
  return {
    type: SET_BACKGROUND,
    payload: {
      id,
      background,
    }
  }
}

export function setIsClosed ({ id, isClosed }) {
  return {
    type: SET_IS_CLOSED,
    payload: {
      id,
      isClosed
    }
  }
}

export function setIsPublic ({ id, isPublic }) {
  return {
    type: SET_IS_PUBLIC,
    payload: {
      id,
      isPublic
    }
  }
}

export function setIsLocked ({ id, isLocked }) {
  return {
    type: SET_IS_LOCKED,
    payload: {
      id,
      isLocked
    }
  }
}
